import React from 'react';
import UploadProduct from '../../components/UploadpageTab/UploadpageTab';
import { PageContainer } from './UploadProductPage.styles';

export default function UploadProductPage() {
    return (
        <PageContainer>
            <UploadProduct />
        </PageContainer>
    );
}
